import React from 'react';
import { track } from '@bnnvara/analytics/src/track';
import { useBrand } from '@bnnvara/brand';
import { LikeButton as StyledLikeButton } from '@bnnvara/buttons';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import { utmParams } from '../../helpers/utmParams';
import { stripQueryParams } from '../../helpers/stripQueryParams';
import { useFingerprint } from '../../hooks/fingerprint';

import * as S from './styled';
import { useLikes } from './useLikes';

export const LikeButton = ({ id, type: contentType, slug }) => {
  const { asPath } = useRouter();
  const fingerprint = useFingerprint();
  const utm = utmParams();
  const { slug: brandSlug, id: brandId } = useBrand();

  const { isLikedByUser, isReady, likeCount, toggle } = useLikes({
    brandSlug,
    contentType,
    id,
    slug,
    interactionSlug: stripQueryParams(asPath),
    utm,
    fingerprint,
    brandId,
  });
  const disable = !isReady;

  async function handleClick() {
    const result = await toggle();

    if (result === null) {
      return;
    }

    const label = `${result === false ? 'undo-' : ''}like-${contentType}`;

    track('like-button', 'click', label);
  }

  return (
    <S.StyledLikeButtonContainer>
      <StyledLikeButton
        disable={disable}
        onClick={handleClick}
        isLiked={isLikedByUser}
        likes={likeCount === undefined ? 0 : likeCount}
      />
    </S.StyledLikeButtonContainer>
  );
};

LikeButton.propTypes = {
  type: PropTypes.oneOf(['media', 'article']).isRequired,
  slug: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

LikeButton.defaultProps = {
  slug: null,
};
